import apiClient from '../utils/apiClient';

export interface SiteMetadata {
  site_code: string;
  org?: string;
  suborg?: string;
  site_type?: string;
  state?: string;
  aft_site_type_code?: string;
  aft_site_type?: string;
  country?: string;
  region?: string;
  site_status?: string;
  locations: string[];
  process_paths: string[];
  // Per-field dropdown catalog captured from AUSTIN, keyed by Navigator field name.
  // Value is a flat option list or, for hierarchical fields, a parent -> options map.
  dropdown_options: Record<string, string[] | Record<string, string[]>>;
  // User aliases belonging to this site (admin-managed roster).
  members: string[];
}

export const siteService = {
  async fetchSiteCodes(): Promise<string[]> {
    const response = await apiClient.get('/api/site/site_codes');
    return response.data;
  },

  async fetchSiteMetadata(siteCode: string): Promise<SiteMetadata> {
    const response = await apiClient.get(`/api/site/metadata/${siteCode}`);
    return response.data;
  },

  async updateSiteMembers(siteCode: string, members: string[]): Promise<SiteMetadata> {
    const response = await apiClient.post(`/api/site/metadata/${siteCode}/members`, { members });
    return response.data;
  },
};
